import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/constants/src/assets/template-4-preview.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')